import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { Button, Modal, OverlayTrigger, Tooltip, Col, Row } from 'react-bootstrap';

import Select from '../../components/AppSelect';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Swal from 'sweetalert2';

import Grid from '../../components/Grid';
import Timeline from '../../components/Timeline';
import { getStatusBadgeByCode } from '../../utils/StatusUtils';
import { ConvertToMoney } from '../../utils/formattingUtils';
import Sidebar from '../../components/Navigation/Sidebar';
import Topbar from '../../components/Navigation/Topbar';

const SecurityModule = ({
  reduxFetchInvestData,
  investData,
  clients,
  logisticsOperators,
  branches,
  reduxGetLogisticsOperators,
  reduxGetBranches,
  reduxGetClients,
  dispatch,
  reduxGetStatuses,
  statuses,
  reduxfetchInvestDataToDownload,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(10);
  const [search, setSearch] = useState('');
  const [startDateFrom, setStartDateFrom] = useState(null);
  const [startDateTo, setStartDateTo] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [showTimeline, setShowTimeline] = useState(false);
  const [idAddressSelected, setIdAddressSelected] = useState(null);

  const renderTooltip = (title) => <Tooltip id="button-tooltip">{title}</Tooltip>;

  const handleSearch = () => {
    reduxFetchInvestData({
      page: 1,
      offset,
      search,
      from: startDateFrom ? startDateFrom.toISOString() : null,
      to: startDateTo ? startDateTo.toISOString() : null,
      senderIds: selectedClient ? selectedClient.value : null,
      operatorIds: selectedOperator ? selectedOperator.value : null,
      idBranch: selectedBranch ? selectedBranch.value : null,
      state: selectedState ? selectedState.value : null,
    });
  };

  useEffect(() => {
    reduxGetLogisticsOperators();
    reduxGetClients();
    reduxGetBranches({
      page: 1,
      offset: 1000,
      search: '',
      isActive: true,
    });
    reduxGetStatuses({
      page: 1,
      search: '',
      offset: 1000,
    });
    handleSearch();
  }, []);

  const rescheduled = (items) => {
    if (!items || items.length === 0) return '';
    const lastRescheduled = items.find((item) => item.idNewState === 1);
    return lastRescheduled ? new Date(lastRescheduled.date).toLocaleString() : '';
  };

  const handleOpenTimeline = (id) => {
    setIdAddressSelected(id);
    setShowTimeline(true);
  };

  const handleCloseTimeline = () => {
    setIdAddressSelected(null);
    setShowTimeline(false);
  };

  const handleDownload = (data) => {
    Swal.fire(
      'Información',
      'El proceso puede tardar un poco... al finalizar se abrirá el Excel con la información.',
      'info'
    ).then(() => {
      handleShowDownloadHistory(data);
      dispatch({ type: 'SHOW_LOADING' });
    });
  };

  const handleShowDownloadHistory = () => {
    let searchParam = search;

    reduxfetchInvestDataToDownload({
      page: 1,
      offset,
      search: searchParam,
      from: startDateFrom ? startDateFrom.toISOString() : null,
      to: startDateTo ? startDateTo.toISOString() : null,
      senderIds: selectedClient ? selectedClient.value : null,
      operatorIds: selectedOperator ? selectedOperator.value : null,
      idBranch: selectedBranch ? selectedBranch.value : null,
      state: selectedState ? selectedState.value : null,
    });
  };

  const columns = [
    {
      title: '#',
      render: (rowData) => <span>{rowData.idAddress}</span>,
      field: 'idAddress',
      searchable: true,
    },
    {
      title: 'ID externo',
      render: (rowData) => <span>{rowData.externalId}</span>,
      field: 'externalId',
      searchable: true,
    },
    {
      title: 'Guía',
      render: (rowData) => <span>{rowData.trackingId}</span>,
      field: 'trackingId',
      searchable: true,
    },
    {
      title: 'Estado',
      render: (rowData) => getStatusBadgeByCode(rowData.newState.code),
      field: 'state',
    },
    {
      title: 'Guía de Retorno',
      render: (rowData) => <span>{rowData.returnTrackingId}</span>,
      field: 'returnTrackingId',
      searchable: true,
    },
    {
      title: 'Operador',
      render: (rowData) => <span>{rowData.operator?.description}</span>,
      field: 'operator.description',
    },
    {
      title: 'Destinatario',
      render: (rowData) => (
        <span>
          {rowData.firstName} {rowData.lastName}
        </span>
      ),
      field: 'firstName-lastName',
      searchable: true,
    },
    {
      title: 'Dirección Destinatario',
      render: (rowData) => <span>{rowData.addressReceiver}</span>,
      field: 'addressReceiver',
    },
    {
      title: 'Coordenadas',
      render: (rowData) => (
        <span>
          {rowData.lat}, {rowData.lon}
        </span>
      ),
      field: 'coordinates',
    },
    {
      title: 'Teléfono Destinatario',
      render: (rowData) => <span>{rowData.reference1}</span>,
      field: 'reference1',
    },
    {
      title: 'Observaciones',
      render: (rowData) => <span>{rowData.reference2}</span>,
      field: 'reference2',
      searchable: true,
    },
    {
      title: 'Valor a recaudar',
      render: (rowData) => <span>{ConvertToMoney(rowData.collection)}</span>,
      field: 'collection',
      searchable: true,
    },
    {
      title: 'Ciudad',
      render: (rowData) => <span>{rowData.city ? rowData.city.description : ''}</span>,
      field: 'city.description',
      searchable: true,
    },
    {
      title: 'Departamento',
      render: (rowData) => <span>{rowData.city?.department?.description || ''}</span>,
      field: 'city.department.description',
      searchable: true,
    },
    {
      title: 'Remitente',
      render: (rowData) => <span>{rowData.company?.description}</span>,
      field: 'company.description',
    },
    {
      title: 'Bodega',
      render: (rowData) => <span>{rowData.branch?.branchName}</span>,
      field: 'branch.branchName',
    },
    {
      title: 'Fecha de reprogramación',
      render: (rowData) => <span>{rescheduled(rowData.addressRecords)}</span>,
      field: 'rescheduledDate',
    },
    {
      title: 'Opciones',
      render: (rowData) =>
        rowData.isActive &&
        rowData.deleted === 0 && (
          <>
            <OverlayTrigger
              placement="top"
              delay={{ show: 50, hide: 50 }}
              overlay={renderTooltip('Ver Timeline')}
            >
              <button
                title="Timeline"
                className="btn btn-primary btn-sm btn-circle mr-2"
                type="button"
                onClick={() => handleOpenTimeline(rowData.idAddress)}
              >
                <i className="fas fa-info fa-xs"></i>
              </button>
            </OverlayTrigger>
          </>
        ),
    },
  ];

  const handleChangeClient = (selectedOption) => {
    setSelectedClient(selectedOption);
  };

  const handleChangeOperator = (selectedOption) => {
    setSelectedOperator(selectedOption);
  };

  const handleChangeBranch = (selectedOption) => {
    setSelectedBranch(selectedOption);
  };

  const handleChangeState = (selectedOption) => {
    setSelectedState(selectedOption);
  };

  const handleChangeFromDate = (date) => {
    if (date) {
      const startOfDay = new Date(date);
      startOfDay.setHours(0, 0, 0, 0);
      setStartDateFrom(startOfDay);
    } else {
      setStartDateFrom(null);
    }
  };

  const handleChangeToDate = (date) => {
    if (date) {
      const endOfDay = new Date(date);
      endOfDay.setHours(23, 59, 59, 999);
      setStartDateTo(endOfDay);
    } else {
      setStartDateTo(null);
    }
  };

  return (
    <div>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Topbar />
            <div className="container-fluid">
              <div className="d-sm-flex align-items-center mb-1">
                <h1 className="h3 mb-0 text-gray-800 mr-3">Novedades</h1>
              </div>
              <p className="mb-4">Módulo de Órdenes que presentan Novedades</p>
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">Órdenes con novedad</h6>
                </div>
                <div className="card-body">
                  <Row>
                    <Col md={2.5} className="mx-3">
                      <label>Desde</label>
                      <br />
                      <DatePicker
                        selected={startDateFrom}
                        onChange={handleChangeFromDate}
                        dateFormat="MM-dd-yyyy"
                        maxDate={new Date()}
                        showTimeSelect
                        peekNextMonth
                        className="form-control"
                        isClearable
                      />
                    </Col>
                    <Col md={2.5}>
                      <label>Hasta</label>
                      <br />
                      <DatePicker
                        selected={startDateTo}
                        onChange={handleChangeToDate}
                        dateFormat="MM-dd-yyyy"
                        maxDate={new Date()}
                        minDate={startDateFrom}
                        showTimeSelect
                        peekNextMonth
                        className="form-control"
                        isClearable
                      />
                    </Col>
                    <Col>
                      <label htmlFor="senderIds" className="form-label">
                        Remitente
                      </label>
                      <Select
                        id="senderIds"
                        onChange={handleChangeClient}
                        isClearable={true}
                        options={
                          clients && clients.items
                            ? clients.items
                                .filter((f) => f.isActive)
                                .map((e) => ({
                                  value: e.idCompany,
                                  label: e.description,
                                }))
                            : []
                        }
                      />
                    </Col>
                    <Col>
                      <label htmlFor="operatorIds" className="form-label">
                        Operador
                      </label>
                      <Select
                        id="operatorIds"
                        onChange={handleChangeOperator}
                        isClearable={true}
                        options={
                          logisticsOperators && logisticsOperators.items
                            ? logisticsOperators.items
                                .filter((f) => f.isActive)
                                .map((ele) => ({
                                  value: ele.idCompany,
                                  label: ele.description,
                                }))
                            : []
                        }
                      />
                    </Col>
                    <Col>
                      <label htmlFor="branch" className="form-label">
                        Bodega
                      </label>
                      <Select
                        id="branch"
                        onChange={handleChangeBranch}
                        isClearable={true}
                        options={
                          branches && branches.items
                            ? branches.items
                                .filter((f) => f.isActive)
                                .map((ele) => ({
                                  value: ele.idBranch,
                                  label: ele.branchName,
                                }))
                            : []
                        }
                      />
                    </Col>
                    <Col>
                      <label htmlFor="state" className="form-label">
                        Estado
                      </label>
                      <Select
                        isClearable={true}
                        id="state"
                        onChange={handleChangeState}
                        options={
                          statuses && Object.keys(statuses).length > 0
                            ? [
                                ...statuses.items
                                  .filter((ele) => ['INVEST', 'NOENTR'].includes(ele.code))
                                  .map((ele) => ({
                                    value: ele.code,
                                    label: ele.name,
                                  })),
                              ]
                            : []
                        }
                      />
                    </Col>
                    <Col>
                      <div style={{ display: 'flex', gap: '10px', marginTop: '32px' }}>
                        <Button className="btn btn-primary" onClick={handleSearch}>
                          Buscar
                        </Button>
                        <Button className="btn btn-primary" onClick={handleDownload}>
                          Descargar
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <br />
                  <Grid
                    cols={columns}
                    data={investData && Object.keys(investData).length > 0 ? investData.items : []}
                    page={
                      investData && Object.keys(investData).length > 0
                        ? Number(investData.page)
                        : currentPage
                    }
                    pages={
                      investData && Object.keys(investData).length > 0
                        ? Number(investData.totalPages)
                        : 0
                    }
                    total={investData && investData.hasOwnProperty('total') ? investData.total : 0}
                    offset={offset}
                    defaultValue={search}
                    onChangePage={(page) => {
                      setCurrentPage(page);
                      reduxFetchInvestData({
                        page: page,
                        offset,
                        search,
                        from: startDateFrom ? startDateFrom.toISOString() : null,
                        to: startDateTo ? startDateTo.toISOString() : null,
                        senderIds: selectedClient ? selectedClient.value : null,
                        operatorIds: selectedOperator ? selectedOperator.value : null,
                        idBranch: selectedBranch ? selectedBranch.value : null,
                        state: selectedState ? selectedState.value : null,
                      });
                    }}
                    onChangeRange={(value) => {
                      setOffset(value);
                      reduxFetchInvestData({
                        page: 1,
                        offset: value,
                        search,
                        from: startDateFrom ? startDateFrom.toISOString() : null,
                        to: startDateTo ? startDateTo.toISOString() : null,
                        senderIds: selectedClient ? selectedClient.value : null,
                        operatorIds: selectedOperator ? selectedOperator.value : null,
                        idBranch: selectedBranch ? selectedBranch.value : null,
                        state: selectedState ? selectedState.value : null,
                      });
                    }}
                    onChangeSearch={(value) => {
                      setSearch(value);
                      reduxFetchInvestData({
                        page: 1,
                        offset,
                        search: value,
                        from: startDateFrom ? startDateFrom.toISOString() : null,
                        to: startDateTo ? startDateTo.toISOString() : null,
                        senderIds: selectedClient ? selectedClient.value : null,
                        operatorIds: selectedOperator ? selectedOperator.value : null,
                        idBranch: selectedBranch ? selectedBranch.value : null,
                        state: selectedState ? selectedState.value : null,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="xl"
        show={showTimeline}
        onHide={handleCloseTimeline}
        onEscapeKeyDown={handleCloseTimeline}
        backdrop="static"
        keyboard={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Timeline - Orden #{idAddressSelected}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Timeline idAddress={idAddressSelected} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  investData: state.investDataState.investData,
  clients: state.companyState.clients,
  logisticsOperators: state.companyState.logisticsOperators,
  branches: state.branchState.branches,
  statuses: state.statusesState.statuses,
});

const mapDispatchToProps = (dispatch) => ({
  reduxFetchInvestData: (payload) =>
    dispatch({
      type: 'FETCH_INVEST_DATA_REQUESTING',
      value: payload,
    }),
  reduxGetLogisticsOperators: (payload) =>
    dispatch({
      type: 'FETCH_COMPANIESBYLOGISTICSOPERATOR_REQUEST',
      value: payload,
    }),
  reduxGetBranches: (payload) =>
    dispatch({
      type: 'FETCH_BRANCHES_REQUEST',
      value: payload,
    }),
  reduxGetClients: (payload) =>
    dispatch({
      type: 'FETCH_COMPANIESBYSHIPPER_REQUEST',
      value: payload,
    }),
  dispatch,
  reduxGetStatuses: (payload) =>
    dispatch({
      type: 'FETCH_NEW_STATUS_REQUEST',
      value: payload,
    }),
  reduxfetchInvestDataToDownload: (payload) =>
    dispatch({
      type: 'FETCH_INVEST_DATA_TO_DOWNLOAD_REQUESTING',
      value: payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SecurityModule);
